<app-aggregated-amount-item
  name="UM 特設ページビュー"
  icon="./assets/universal_music.png"
  amount="{{ (specialUmhpPageView$ | async)?.units }}"
  unit="ページビュー数"
  [rate]="(specialUmhpPageView$ | async)?.rate"
  link=""
  help="{{
    (selectedArtist$ | async).nameMain
  }}の UM 特設サイトページビュー数です。ページビュー数は選択期間内の合計数です。"
  [hasAmount]="(specialUmhpPageView$ | async)?.hasUnits"
  [loading]="loading$ | async"
  [dataCollections]="dataCollections$ | async"
  [dataCollectLoading]="dataCollectLoading$ | async"
></app-aggregated-amount-item>
